import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { fetchNavi, switchLang } from '../../redux/actions';
import LangWrapper from '../../components/LangWrapper';
import { fetchDate } from '../../redux/actions';
// import slug from 'slug'

import SubNav from '../../components/SubNav';

import './Header.css';
import './MobileNav.css';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      navigationOpen: false,
      menuOpen: false,
    }
  }

  componentDidMount() {
    const locale = this.props.intl.locale;

    this.props.fetchDate();

    if (!this.props.navi) {
      this.props.fetchNavi(locale);
    }

    let lastScrollTop = 0

    window.addEventListener('scroll', function() {
      let nav = document.querySelector('header.sticky-header')
      let st = window.pageYOffset || document.documentElement.scrollTop

      if (st > lastScrollTop){
        // downscroll
        if(window.pageYOffset > nav.offsetHeight) {
          nav.classList.remove('full')
          nav.classList.add('hide')
          if(window.pageYOffset > 500) {
            nav.classList.remove('hide')
            nav.classList.add('sticky')
          }
        }
      } else {
        // upscroll

        if(window.pageYOffset > 500) {
          nav.classList.add('full')
        }
        else {
          nav.classList.add('hide')
          if(window.pageYOffset < 300) {
            nav.classList.remove('sticky')
            nav.classList.remove('full')
            nav.classList.remove('hide')
          }
        }
      }
      lastScrollTop = st;
    })
  }

  componentDidUpdate() {
    window.scroll(0, 0);
  }

  handleNavToggle() {
    if(this.state.navigationOpen) {
      this.setState({
        navigationOpen: false
      })
    }
    else {
      // if(window.innerWidth <= 767) {
        this.setState({
          navigationOpen: true
        })
      // }
    }
  }

  handleMenu() {
    if(this.state.menuOpen) {
      this.setState({
        menuOpen: false
      })
    }
    else {
      this.setState({
        menuOpen: true
      })
    }
  }

  onSwitchLang() {
    this.props.switchLang();
    window.location.reload();
  }

  render() {
    const locale = this.props.intl.locale;
    const {naviItems, match} = {...this.props};
    const currentSlug = match.params.slug;

    let children;

    return (
      <header className="main-header sticky-header">
        <NavLink to="/"><span className="logo">W Restaurants</span></NavLink>
        <nav>
          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <NavLink key={`navilink_${i}`} to={`/${mainPage.fields.slug}`} activeClassName="active" className={isCurrent?'active':null}>
                  {item.label}
                </NavLink>
              );
            })
          }
          {/*<NavLink to="/blog" activeClassName="active">{this.props.intl.messages["header.blog"]}</NavLink>*/}
          <NavLink to="/contact" activeClassName="active">{this.props.intl.messages["header.contactUs"]}</NavLink>

          { children &&
            <SubNav
              onNav={() => this.handleNavToggle()}
              items={children.map(item => ({
                link: `/${item.fields.slug}`,
                hidden: false,
                title: item.fields.title,
              })
            )} />
          }
        </nav>

        <LangWrapper onSwitch={() => this.onSwitchLang()} />

        <span className="nav-toggle" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>

        <nav className={'mobile-nav '+(this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />
          <NavLink to={locale==='en'?'/en':'/'} className="logo" onClick={this.handleNavToggle.bind(this)}><span>W Restaurants</span></NavLink>

          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              let children;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <span key={`navilink_${i}`}>
                  <NavLink to={`/${mainPage.fields.slug}`} activeClassName="active" onClick={this.handleNavToggle.bind(this)}>
                    {item.label}
                  </NavLink>
                  { children &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={children.map(item => ({
                        link: `/${item.fields.slug}`,
                        hidden: false,
                        title: item.fields.title,
                      })
                    )} />
                  }
                </span>
              );
            })
          }
          {/*<NavLink to="/blog" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["header.blog"]}</NavLink>*/}
          <NavLink to="/contact" activeClassName="active" onClick={this.handleNavToggle.bind(this)}><FormattedMessage id="header.contactUs" /></NavLink>

          <LangWrapper onSwitch={() => this.onSwitchLang()} />
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  naviItems: state.navi,
  date: state.date,
});

const mapDispatchToProps = {
  fetchNavi,
  fetchDate,
  switchLang
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js